import React from 'react';
import { motion } from 'framer-motion';
import { MapPin, Utensils, Coffee, Music, Sun, Ship, Landmark, TreePine, Clock, Ticket, Cpu } from 'lucide-react';
const scheduleData = [{
  day: 'Friday, June 26',
  title: 'Arrival & Welcome',
  events: [{
    time: '11:00 AM – 2:00 PM',
    name: 'Arrival, Check-in & Family Field Day Kick Off',
    detail: 'Presidio: Western Lawn\nParking/Uber drop-off: Anza Ave or French Court (French Court is closer to Western Lawn)',
    icon: Sun,
    mandatory: true,
    link: 'https://maps.app.goo.gl/Tu1vs9aovgNkjQnW8'
  }, {
    time: 'Afternoon',
    name: 'Explore SF',
    detail: 'Pier 39, SFMOMA, Chinatown',
    icon: Landmark,
    mandatory: false
  }, {
    time: '3:00 – 5:00 PM',
    name: 'Zipline (Company) Tour',
    detail: '333 Corey Way, South San Francisco, CA 94080\nFor anyone interested in drones or robotics: tour the headquarters of Zipline, a drone delivery company rolling out instant deliveries in the US now.',
    icon: Cpu,
    mandatory: false,
    link: 'https://maps.google.com/?q=333+Coprey+Way,+South+San+Francisco,+CA+94080'
  }, {
    time: '5:30 - 8:30 PM',
    name: 'Banquet Dinner',
    detail: 'Epic Steak - Bay Room & Terrace',
    icon: Utensils,
    mandatory: true,
    link: 'https://www.epicsteak.com/'
  }]
}, {
  day: 'Saturday, June 27',
  title: 'Adventure & Feast',
  events: [{
    time: 'Morning',
    name: 'Optional: Ferry Building Farmers Market',
    detail: 'Browse local vendors and grab breakfast',
    icon: Coffee,
    mandatory: false
  }, {
    time: 'Daytime',
    name: 'Choose Your Adventure',
    detail: "Option A: Boat ride to Angel Island + lobster boil lunch at South Beach Harbor (hosted by Kingsley's family)\n• Arrive by 9:45 AM for boarding — the boat leaves at 10:15 AM, no exceptions!\n• Wear comfortable shoes for hiking around the island — no heels.\n• Lobster boil lunch promptly at 12:00 PM sharp on the island.\n• Restrooms available on the boat and on the island.\n• Be prepared to get messy and eat lobster! If you have a seafood/shellfish allergy, please bring your own food.\n• Bring anything you'd like to play with on the beach!\n• We return to SF at 3:00 PM.",
    detailLink: 'https://www.sfport.com/maritime/harbors-berthings/south-beach-harbor/sbh-transit-and-parking-information',
    detailLinkLabel: 'Boat harbor parking & transit →',
    detailB: 'Option B: De Young Museum + Golden Gate Park + Cal Academy (self-guided)',
    icon: Ship,
    mandatory: false
  }, {
    time: '5:30 PM',
    name: 'Banquet Dinner',
    detail: 'Harborview — Chinese cuisine',
    icon: Utensils,
    mandatory: true,
    link: 'https://www.harborviewsf.com/'
  }]
}, {
  day: 'Sunday, June 28',
  title: 'Brunch & Farewell',
  events: [{
    time: '10:00 AM',
    name: 'Dim Sum Brunch',
    detail: 'Yank Sing - Spear Street',
    icon: Coffee,
    mandatory: false,
    link: 'https://yanksing.com/'
  }, {
    time: '1:05 PM',
    name: 'Giants Game',
    detail: "Oracle Park — catch a game before you go! (hosted by Kingsley's family)",
    icon: Ticket,
    mandatory: false
  }]
}];
export function Schedule() {
  return <section className="py-24 px-6 bg-paper-alt relative border-y border-ink/5" data-id="element-113">
      <div className="max-w-4xl mx-auto" data-id="element-114">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="text-center mb-16" data-id="element-115">
          <h2 className="text-4xl md:text-5xl text-ink mb-4" data-id="element-116">
            Weekend Itinerary
          </h2>
          <p className="text-ink-light text-lg" data-id="element-117">
            A mix of must-dos and choose-your-own-adventure.
          </p>
        </motion.div>

        <div className="space-y-16" data-id="element-118">
          {scheduleData.map((day, dayIndex) => <motion.div key={day.day} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.6,
          delay: dayIndex * 0.2
        }} className="relative" data-id="element-119">
              <div className="flex flex-col md:flex-row gap-8" data-id="element-120">
                {/* Day Header */}
                <div className="md:w-1/3 md:text-right" data-id="element-121">
                  <h3 className="text-2xl text-terracotta mb-1" data-id="element-122">{day.day}</h3>
                  <p className="text-sage italic" data-id="element-123">{day.title}</p>
                </div>

                {/* Timeline Line (Desktop) */}
                <div className="hidden md:flex flex-col items-center relative" data-id="element-124">
                  <div className="w-3 h-3 rounded-full bg-amber z-10" data-id="element-125" />
                  <div className="w-px h-full bg-ink/10 absolute top-3" data-id="element-126" />
                </div>

                {/* Events */}
                <div className="md:w-2/3 space-y-6 pb-8" data-id="element-127">
                  {day.events.map((event, eventIndex) => {
                const Icon = event.icon;
                return <div key={eventIndex} className="flex items-start gap-4 bg-paper p-4 rounded-sm shadow-sm border border-ink/5" data-id="element-128">
                        <div className="p-2 bg-sage/10 rounded-full text-sage shrink-0" data-id="element-129">
                          <Icon className="w-5 h-5" data-id="element-130" />
                        </div>
                        <div className="flex-1" data-id="element-131">
                          <div className="flex items-center gap-2 mb-1 flex-wrap" data-id="element-132">
                            <span className="text-sm text-amber font-medium" data-id="element-133">
                              {event.time}
                            </span>
                            {event.mandatory ? <span className="text-[10px] uppercase tracking-wider bg-terracotta/10 text-terracotta px-2 py-0.5 rounded-sm font-semibold" data-id="element-134">
                                Group
                              </span> : <span className="text-[10px] uppercase tracking-wider bg-sage/10 text-sage px-2 py-0.5 rounded-sm font-semibold" data-id="element-135">
                                Optional
                              </span>}
                          </div>
                          <div className="text-ink text-lg" data-id="element-136">{event.name}</div>
                          {event.detail && <p className="text-ink-light text-sm mt-1 whitespace-pre-line" data-id="element-137">
                              {event.detail}
                            </p>}
                          {event.detailLink && <a href={event.detailLink} target="_blank" rel="noopener noreferrer" className="inline-block text-sm text-terracotta hover:underline mt-1" data-id="element-138">
                              {event.detailLinkLabel || 'Map →'}
                            </a>}
                          {event.detailB && <p className="text-ink-light text-sm mt-3 whitespace-pre-line" data-id="element-139">
                              {event.detailB}
                            </p>}
                          {event.link && <a href={event.link} target="_blank" rel="noopener noreferrer" className="inline-block text-sm text-terracotta hover:underline mt-1" data-id="element-140">
                              Map →
                            </a>}
                        </div>
                      </div>;
              })}
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}